import React from 'react';
import { useTranslation } from 'react-i18next';
import get from 'lodash/get';
import groupBy from 'lodash/groupBy';

import { Cell, Grid, GridContainer } from 'formlabs-web-components/Grid';
import {
  Accordion,
  AccordionItem,
  Picture
} from 'formlabs-web-components/Media';
import { Spinner } from 'formlabs-web-components/Navigation';
import { Header } from 'formlabs-web-components/Type';

import ProductOptionControl, {
  ProductOptionListControl
} from '../../ProductOptionControl';
import Price from '../../Price';
import CheckmarkList from '../../../content/CheckmarkList';
import useIsMobile from '../../../../hooks/useIsMobile';

// for displaying "Whats included". Duplicate products are summed up.
const extractIncludedOptionStrings = bundle => {
  const includedOptions = get(bundle, 'bundle_product_options', []).reduce(
    (products, option) => {
      return [
        ...products,
        ...option['product_links'].filter(
          link => link['is_default'] && link.qty > 0
        )
      ];
    },
    []
  );
  const groupedIncludedOptions = groupBy(
    includedOptions,
    option => option.name
  );
  return Object.keys(groupedIncludedOptions).map(name => {
    const options = groupedIncludedOptions[name];
    const qty = options.reduce((sum, option) => sum + option.qty, 0);
    return qty > 1 ? `${qty} x ${name}` : name;
  });
};

const PackageStep = ({
  activeSku,
  bundles,
  cdnUrl,
  setActiveSku,
  loading,
  image
}) => {
  const [t] = useTranslation();
  const isMobile = useIsMobile(640);

  return (
    <div style={{ marginBottom: '2rem' }}>
      <GridContainer>
        <Grid direction="x" gutters="margin">
          <Cell smallSize={24} mediumSize={12}>
            {image && <Picture largeImage={`${cdnUrl}${image}`} />}
          </Cell>
          <Cell smallSize={24} mediumSize={12}>
            <Header level={2} displayAs={3}>
              {t('Build Your Fuse 1 Package')}
            </Header>
            <p>
              {t(
                'Configure your Fuse 1 ecosystem to fit your business’s prototyping and production needs.'
              )}
            </p>
            <p style={{ fontWeight: '600' }}>
              {t('Start with a preset and continue to customize your setup.')}
            </p>
            <ProductOptionListControl>
              {bundles.map(bundle => {
                const isActive = bundle.sku === activeSku;

                return (
                  <ProductOptionControl
                    key={bundle.sku}
                    controlPosition="top"
                    name={bundle.sku}
                    value={bundle.sku}
                    title={bundle.name}
                    isActive={isActive}
                    hatTitle={bundle.recommended && t('Recommended')}
                    onChange={e => {
                      setActiveSku(e.target.value);
                    }}
                    type="radio"
                  >
                    {loading ? (
                      <Spinner size={3} color="#0762c8" />
                    ) : (
                      <>
                        {bundle.displayPrice && (
                          <Price price={bundle.displayPrice} />
                        )}

                        <div
                          dangerouslySetInnerHTML={{
                            __html: get(
                              bundle,
                              'attributes.shortDescription',
                              null
                            )
                          }}
                        />

                        <Accordion type="inline-arrow">
                          <AccordionItem
                            title={t('What’s Included')}
                            open={isActive}
                          >
                            <CheckmarkList
                              width={isMobile ? 1 : 2}
                              items={extractIncludedOptionStrings(bundle)}
                              light
                              narrow
                            />
                          </AccordionItem>
                        </Accordion>
                      </>
                    )}
                  </ProductOptionControl>
                );
              })}
            </ProductOptionListControl>
          </Cell>
        </Grid>
      </GridContainer>
    </div>
  );
};

export default PackageStep;
